import { Component, Input, AfterViewInit } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import {ProductBarcodeService} from '../../../../api/product-barcode.service';
import {PostalCodeMappingService} from '../../../../api/postal-code-mapping.service';


@Component({
	selector: 'app-postal-code-detail-view',
	templateUrl: 'postal-code-detail-view.component.html',
	providers: [],
})
export class PostalCodeDetailViewComponent implements AfterViewInit {
	@Input() key: number;

	public processingStatusForPostalCodeMappingData: any = {};

	constructor(
		private postalCodeMappingService: PostalCodeMappingService,
	) {
	}

	ngAfterViewInit() {
		this.processingStatusForPostalCodeMappingData = new CustomStore({
			key: 'PostalCodeMappingProcessingStatusId',
			load: (loadOptions: any) => {
				return this.postalCodeMappingService.getProcessingStatusForPostalCodeMappingResult(loadOptions, this.key)
					.toPromise()
					.then((data: any) => {
						return {
							data: data.data,
							totalCount: data.totalCount,
							summary: data.summary,
							groupCount: data.groupCount
						};
					})
					.catch(error => { throw new Error('Data Loading Error'); });
			}
		});
	}
}
